<template>
  <el-dialog
    title="添加工种类型"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%">
    
    <div class="product-add pb50">
      <el-form size="small" :model="form" ref="form" :rules="rules" label-width="120px">
        <div class="common-form">添加工种类型</div>
        
        <!-- 新增：所属分类选择 -->
        <el-form-item label="所属分类" prop="parent_id">
          <el-select v-model="form.parent_id" clearable placeholder="请选择所属分类">
            <el-option label="顶级分类" :value="0"></el-option>
            <el-option 
              v-for="item in parentList" 
              :key="item.employment_type_id"
              :value="item.employment_type_id" 
              :label="item.parent_id === 0 ? `${item.name}` : `${item.name}`">
            </el-option>
          </el-select>
          <!-- <div style="color: #999; font-size: 12px; margin-top: 5px;">
            提示：选择"顶级分类"为一级分类，选择其他分类则为二级分类
          </div> -->
        </el-form-item>
        
        <el-form-item label="工种类型名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入工种类型名称"></el-input>
        </el-form-item>
        
        <el-form-item label="工种类型图片" prop="image">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.image">
              <transition-group>
                <div v-for="(item, index) in form.image" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)">
                      <i class="el-icon-close"></i>
                    </a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>
        
        <el-form-item label="排序" prop="sort">
          <el-input v-model.number="form.sort" placeholder="请输入排序"></el-input>
        </el-form-item>
        
        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
          <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
        </div>
      </el-form>
      
      <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">
        上传图片
      </Upload>
    </div>
  </el-dialog>
</template>

<script>
import Employment_typeApi from '@/api/employment_type.js';
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";

export default {
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      form: {
        name: '',
        parent_id: 0, // 父级ID字段
        image: [],
        sort: 50,
      },
      parentList: [], // 可选的父级分类列表
      loading: false,
      rules: {
        name: [{ required: true, message: '请输入工种类型名称', trigger: 'blur' }],
        sort: [{ type: 'number', message: '排序必须为数字' }]
      },
      dialogVisible: false,
      isProductUpload: false,
    };
  },
  props: ["open_add", "default_parent_id"],
  created() {
    this.dialogVisible = this.open_add;
    this.getParentList();
  },
  methods: {
    /*获取可选的父级分类列表*/
    getParentList() {
      Employment_typeApi.getParents({}, true).then(data => {
        this.parentList = data.data.list;
      });
    },
    
    /*提交*/
    onSubmit() {
      let self = this;
      if(self.form.image.length <= 0){
        self.$message({ message: "请上传图片", type: 'error' });
        return;
      }
      
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Employment_typeApi.add(self.form, true)
            .then(data => {
              self.loading = false;
              self.$message({ message: '添加成功', type: 'success' });
              self.dialogFormVisible();
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },
    
    /*关闭弹窗*/
    dialogFormVisible() {
      this.$emit("close", {});
    },
    
    cancelFunc() {
      this.dialogFormVisible();
    },
    
    /*图片上传相关方法*/
    openProductUpload() {
      this.isProductUpload = true;
    },
    
    returnProductImgsFunc(e) {
      if (e != null) {
        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      this.isProductUpload = false;
    },
    
    deleteImg(index) {
      this.form.image.splice(index, 1);
    },
  }
};
</script>

<style scoped>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/employment_type/index/part/add.vue